import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface CloseCircleIconProps {
  color?: string;
  size?: number;
  [x: string]: unknown;
}

const CloseCircleIcon = ({ color, size = 24, ...rest }: CloseCircleIconProps) => {
  const { token } = useToken();

  const iconColor = color ?? token.colorError;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Icon / CloseCircleTwoTone">
        <path
          id="Vector"
          d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z"
          fill={iconColor}
        />
        <path
          id="Vector_2"
          opacity="0.1"
          d="M12 3.28125C7.18594 3.28125 3.28125 7.18594 3.28125 12C3.28125 16.8141 7.18594 20.7188 12 20.7188C16.8141 20.7188 20.7188 16.8141 20.7188 12C20.7188 7.18594 16.8141 3.28125 12 3.28125ZM16.0266 15.6352C16.0547 15.6703 16.0711 15.7125 16.0711 15.757C16.0711 15.8625 15.9867 15.9445 15.8836 15.9445L14.3367 15.9375L12.0094 13.1625L9.68203 15.9398L8.13281 15.9469C8.02969 15.9469 7.94531 15.8625 7.94531 15.7594C7.94531 15.7148 7.96172 15.6727 7.98984 15.6375L11.0391 12.007L7.98984 8.37422C7.96152 8.33987 7.94581 8.29686 7.94531 8.25234C7.94531 8.14688 8.02969 8.06484 8.13281 8.06484L9.68203 8.07187L12.0094 10.8469L14.3391 8.06953L15.8859 8.0625C15.9891 8.0625 16.0734 8.14687 16.0734 8.25C16.0734 8.29453 16.0594 8.33906 16.0312 8.37188L12.982 12.0047L16.0266 15.6352Z"
          fill={iconColor}
        />
        <path
          id="Vector_3"
          d="M16.0734 8.25C16.0734 8.14687 15.9891 8.0625 15.8859 8.0625L14.3391 8.06953L12.0094 10.8469L9.68203 8.07187L8.13281 8.06484C8.02969 8.06484 7.94531 8.14688 7.94531 8.25234C7.94531 8.29688 7.96172 8.33906 7.98984 8.37422L11.0391 12.007L7.98984 15.6375C7.96152 15.6719 7.94581 15.7149 7.94531 15.7594C7.94531 15.8625 8.02969 15.9469 8.13281 15.9469L9.68203 15.9398L12.0094 13.1625L14.3367 15.9375L15.8836 15.9445C15.9867 15.9445 16.0711 15.8625 16.0711 15.757C16.0711 15.7125 16.0547 15.6703 16.0266 15.6352L12.982 12.0047L16.0312 8.37188C16.0594 8.33906 16.0734 8.29453 16.0734 8.25Z"
          fill={iconColor}
        />
      </g>
    </svg>
  );
};

export default CloseCircleIcon;
